import styles from "./styles.module.css"

export default function InputFileBook({ value, setFile }) {
    return (
        <div className={styles.inputFileBook}>
            <label htmlFor="file_ebook">
                Adicionar um arquivo de livro (.epub)
                <input required onChange={(event) => { setFile(event.target.files[0]) }} accept="application/epub+zip" name="file_ebook" type="file"></input>
            </label>
        </div>
    );
}